import useTranslate from "@/hooks/useTranslate/useTranslate";

import type { I_UseValidate_Return } from "../index";

export default function nameValidation(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: "",
        };
    }

    if (value.length < 2) {
        return {
            status: false,
            message: useTranslate("tiw__validation__name_minLength"),
        };
    }

    return {
        status: true,
        message: "",
    };
}
